import { render } from "./OwnershipSelection.vue?vue&type=template&id=251a4171"
import script from "./OwnershipSelection.vue?vue&type=script&lang=js"
export * from "./OwnershipSelection.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__